var _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(-90 0.5 23.5)",
    stroke: "#538FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 14,
    height: 14,
    rx: 7,
    transform: "rotate(-90 5 19)",
    fill: "#538FFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1815_180043",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 14,
    height: 14,
    rx: 7,
    transform: "rotate(-90 5 19)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1815_180043)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checkedIcon.f9920ee3.svg";
export { ForwardRef as ReactComponent };